import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface GpsVehicle {
  id: string;
  company_id: string;
  plate: string;
  make?: string;
  model?: string;
  year?: number;
  color?: string;
  chassis?: string;
  renavam?: string;
  status: 'active' | 'inactive' | 'maintenance';
  notes?: string;
  created_at: string;
  updated_at: string;
}

/**
 * Hook para buscar veículos do FleetONE
 * GPS agora usa SEMPRE os veículos do FleetONE
 */
export const useGpsVehicles = (companyId?: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ['fleet-vehicles', companyId],
    queryFn: async (): Promise<GpsVehicle[]> => {
      if (!companyId) return [];

      const { data, error } = await supabase
        .from('fleet_vehicles')
        .select('id, company_id, plate, make, model, year, status, created_at, updated_at')
        .eq('company_id', companyId)
        .eq('status', 'active');

      if (error) throw error;
      return (data || []) as any;
    },
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000,
  });

  return {
    data,
    isLoading,
    isFleetSource: true, // Sempre usa FleetONE agora
  };
};
